module.exports = __webpack_public_path__ + "img/upload-loading.bfc4e69a.svg";